import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";

@Injectable({ providedIn: 'root'})
export class ProdFormulaFileService{
    constructor(private _http: HttpClient){}

    getUploadUrl(fileName: string){

        return this._http.get<any>(`${environment.rydApiUrl}/api/ryd/upload/${fileName}`);

    }

    getDownloadUrl(fileName: string) {
        return this._http.get<any>(`${environment.rydApiUrl}/api/ryd/download/${fileName}`);
      }

    uploadFile(url: string,contentType,file){
        let headers = new HttpHeaders().set('Content-Type', contentType).set('x-ms-blob-type','BlockBlob');
        return this._http.put<any>(url,file,{ headers: headers});        
    }
}
